import React from 'react'

import { Link } from 'react-router-dom'

import logos from './../../UI/loading/Logo_Intro.svg'
import comerciales from './../../UI/loading/intro_comerciales.webp'
import particulares from './../../UI/loading/intro-particulares.webp'

interface Props{
    isIntroShowed: boolean,
    handleOpenTutorialVideo: any
}

interface State{
    currentOver: number
}

class WelcomeMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            currentOver: -1
        } 
    }

    handleShowOver = (index: number) => {
        this.setState({
            currentOver: index
        })
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isIntroShowed ? "welcome-main-mobile fade-in":"welcome-main-mobile fade-out"}>
                <img className='welcome-logos-mobile' src={logos}/>
                <div className='welcome-text-mobile'>
                    Bienvenido <br/> ¿Qué vehículo buscas?
                </div>
                <div className='showroom-selector-container-mobile'>
                    <Link to="/vehiculos-particulares/" onMouseEnter={() => {this.handleShowOver(0)}} onMouseLeave={() => {this.handleShowOver(-1)}}> 
                        <div className='welcome-selector-container-mobile' >
                            <img src={particulares}></img>
                        </div>
                        <div className={this.state.currentOver === 0 ? 'over-selected-show-mobile':'over-selected-hidden-mobile'}>{this.state.currentOver === 0 ? "Vehículos particulares":""}</div>
                    </Link>
                    <Link to="/vehiculos-comerciales/" onMouseEnter={() => {this.handleShowOver(1)}} onMouseLeave={() => {this.handleShowOver(-1)}}> 
                        <div className='welcome-selector-container-mobile' >
                            <img src={comerciales}></img>
                        </div>
                        <div className={this.state.currentOver === 1 ? 'over-selected-show-mobile':'over-selected-hidden-mobile'}>{this.state.currentOver === 1 ? "Vehículos comerciales":""}</div>
                    </Link>
                </div>
                <hr className='welcome-hr-mobile'/>
                <div className='tuto-container-mobile'>
                    <div className='tuto-text-mobile'>
                        Contamos con un video instructivo para que aprendas a navegar en el showroom
                    </div>
                    <div className='tuto-btn-mobile' onClick={() => {this.props.handleOpenTutorialVideo()}}>
                        Ver el tutorial
                    </div>
                </div>
            </div>
        )
    }
}

export default WelcomeMobile